import { environment } from '@env/environment';
import { PayrollReport } from '@reporting/interfaces/report.interface';
import { format } from 'date-fns';
import { getInitialDatesForYTD } from './dates';

export class Benefit implements PayrollReport {
    name = 'reporting.payroll.benefit.name';
    description = 'reporting.payroll.benefit.description';
    routerLink = 'benefit';
    apiEndpoint = 'payroll/benefit';
    /*
     * This is an experimental feature, the goal is to hit a service endpoint
     * without having to proxy through our HR application.
     */
    serviceApiEndpoint = environment.payrollUrl + '/v2/companies/:companyId/reporting/benefits';
    allowsInclusionOfPendingPayrolls = false;
    hasExcel = true;
    hasPDF = false;
    hasCSV = true;
    showsPeriod = true;
    filterable = true;

    get fileName(): string {
        return `humi_benefit_report_${format(new Date(), 'YYYY_MM_DD')}`;
    }

    getInitialDates = getInitialDatesForYTD;
}
